import { SidebarProvider } from '@/components/ui/sidebar'
import { AppSidebar } from '@/components/layout/AppSidebar'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { VehicleHealth } from './components/VehicleHealth'
import { UpcomingMaintenance } from './components/UpcomingMaintenance'
import { ServiceHistory } from './components/ServiceHistory'
import { Calendar, History } from 'lucide-react'

export function Maintenance() {
  return (
    <SidebarProvider>
      <div className="flex h-screen w-full">
        <AppSidebar />
        <main className="flex-1 overflow-auto p-6">
          <div className="max-w-7xl mx-auto space-y-6">
            <div>
              <h1 className="text-3xl font-bold tracking-tight">Maintenance Hub</h1>
              <p className="text-muted-foreground">
                Track vehicle maintenance schedules and service history
              </p>
            </div>

            {/* Always visible vehicle health summary */}
            <VehicleHealth />

            <Tabs defaultValue="upcoming" className="space-y-6">
              <TabsList className="grid w-full max-w-md grid-cols-2">
                <TabsTrigger value="upcoming" className="gap-2">
                  <Calendar className="h-4 w-4" />
                  Upcoming
                </TabsTrigger>
                <TabsTrigger value="history" className="gap-2">
                  <History className="h-4 w-4" />
                  History
                </TabsTrigger>
              </TabsList>

              <TabsContent value="upcoming" className="space-y-6">
                <UpcomingMaintenance />
              </TabsContent>

              <TabsContent value="history" className="space-y-6">
                <ServiceHistory />
              </TabsContent>
            </Tabs>
          </div>
        </main>
      </div>
    </SidebarProvider>
  )
}
